<!--
 * @Description:
 * @Author: luoshoufeng@szkingdom.com
 * @Date: 2024-04-30 15:32:31
 * @LastEditors: situgen@szkingdom.com
-->
<template>
    <div>
        <comp-title-dc back-url-name="moneyBox" :back-url-query="{ activeIndex: 2 }">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/moneyBox' }">
                    {{ $const.getXJBParam("name") }}
                </el-breadcrumb-item>
                <el-breadcrumb-item>自动存入</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title-dc>
        <div class="bizcomp-auto-access">
            <div class="auto-access-head">
                <el-tabs v-model="activeIndex" v-on:tab-click="handleSelect">
                    <el-tab-pane name="1">
                        <el-badge slot="label" class="badge-name">
                            <img
                                v-if="activeIndex == 2"
                                src="../../assets/img/money-in.svg"
                                alt=""
                            />
                            <img v-else src="../../assets/img/money-in-select.svg" alt="" />
                            <span :class="activeIndex == 1 ? 'font-w-600' : ''">自动存入</span>
                        </el-badge>
                    </el-tab-pane>
                    <!-- <el-tab-pane name="2">
                        <el-badge slot="label" class="badge-name">
                            <img
                                v-if="activeIndex == 1"
                                src="../../assets/img/money-out.svg"
                                alt=""
                            />
                            <img v-else src="../../assets/img/money-out-select.svg" alt="" />
                            <span :class="activeIndex == 2 ? 'font-w-600' : ''">自动取出</span>
                        </el-badge>
                    </el-tab-pane> -->
                </el-tabs>
            </div>
            <div class="auto-access-content">
                <money-in-list v-if="activeIndex == 1"></money-in-list>
                <money-out-list v-if="activeIndex == 2"></money-out-list>
            </div>
        </div>
        <footer-questions
            v-if="$const.warmReminderDisplay"
            :warning-html="warningHtml"
        ></footer-questions>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import moneyInList from "./moneyInList.vue";
import moneyOutList from "./moneyOutList.vue";
import footerQuestions from "@/components/layout/footerQuestions.vue";
import warningHtml from "@/constant/warning_html.js";

export default {
    name: "AutoAccess",
    components: { moneyInList, moneyOutList, footerQuestions },
    mixins: [mixin],
    data() {
        return {
            activeIndex: "1",
            warningHtml: ""
        };
    },
    created() {
        this.warningHtml = warningHtml.warningHtml12;
        this.activeIndex = this.$route.query.activeIndex ? this.$route.query.activeIndex : "1";
        this.$route.query.activeIndex = this.activeIndex;
    },
    methods: {
        handleSelect() {
            this.$router.push({
                path: this.$route.path,
                query: { activeIndex: this.activeIndex }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.bizcomp-auto-access {
    margin-top: 12px;
    margin-bottom: 20px;
    border: 1px solid #f1f1f1;
    .auto-access-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border: 1px solid #f1f1f1;
        padding-left: 22px;
        .badge-name {
            display: flex;
            align-items: center;
        }
    }
    .auto-access-content {
        padding: 20px;
    }
    :deep(.el-tabs__header) {
        margin: 0;
    }
    :deep(.el-tabs__nav-wrap::after) {
        height: 0 !important;
    }
    :deep(.el-tabs__item) {
        padding: 0;
        width: 130px;
        text-align: center;
        height: 70px;
        line-height: 70px;
        font-family: "Source Han Sans CN";
        font-size: 20px;
        color: #666;
    }
    :deep(.is-active) {
        color: var(--color-primary);
        font-weight: 500;
    }
    :deep(.el-tabs__active-bar) {
        width: 106px !important;
        height: 4px;
        background: var(--color-primary);
        position: absolute;
        top: 59px;
    }
    .font-w-600 {
        font-weight: 600;
    }
}
</style>
